// Billing decline codes thrown by the charge-policy bind step (holdPayments) when Stripe
// rejects the payment hold. Mirrored from `billingErrorCodes` in @ourbranch/be-constants — a
// backend-only package staff-fe does not depend on — keep in sync with that map. The numeric
// code reaches the client only as an `ERROR_CODE: <code>` suffix appended to the error message
// (custom Error properties do not survive Lambda error serialization); formattedError in
// quoter.service.js extracts it, the same channel quote-fe parses.
export const billingErrorCodes = {
  ACH_IS_OWNED_BY_COMPANY: 6001,
  PAYMENT_METHOD_USED_ON_TWO_OR_MORE_ACCOUNTS: 6002,
  CARD_DECLINED: 6003,
  EXPIRED_CARD: 6004,
  PROCESSING_ERROR: 6005,
  INSUFFICIENT_FUNDS: 6006,
  INCORRECT_CVC: 6007,
  GENERIC_DECLINE: 6008,
  CARD_VELOCITY_EXCEEDED: 6009
};

const BILLING_ERROR_CODES = new Set(Object.values(billingErrorCodes));

// Codes round-trip through JSON/tracking as strings, so accept either form.
export const isBillingErrorCode = (code) => BILLING_ERROR_CODES.has(Number(code));
